import { PayloadAction } from '@reduxjs/toolkit';
import { IModal } from '../../core/components/modals/IModal';

export const ModalReducer = {
	toggleModal: (state: IModal, action: PayloadAction<IModal>) => {
		state.isOpen = action.payload.isOpen;
		state.component = action.payload.component;
		state.componentProps = action.payload.componentProps;
		state.closable = action.payload.closable;
		state.position = action.payload.position;
		state.confirmAction = action.payload.confirmAction;
		state.width = action.payload.width ?? 50;
		state.isDarkVersion = action.payload.isDarkVersion;
		state.lastComponent = action.payload.lastComponent;
		state.version = action.payload.version ? action.payload.version : 'v1';
		state.template = action.payload.template;
		state.width = action.payload.width;
		state.showHeader = action.payload.showHeader;
		state.showFooter = action.payload.showFooter;
		state.primaryActionText = action.payload.primaryActionText;
		state.secondaryActionText = action.payload.secondaryActionText;
		state.tertiaryActionText = action.payload.tertiaryActionText;
		state.icon = action.payload.icon;
		state.iconBg = action.payload.iconBg;
		state.iconColor = action.payload.iconColor;
		state.iconHoverColor = action.payload.iconHoverColor;
		state.iconBorder = action.payload.iconBorder;
		state.primaryActionTrigger = null;
		state.secondaryActionTrigger = null;
		state.tertiaryActionTrigger = null;
		state.additionalFooterContent = action.payload.additionalFooterContent;
		state.isDisabledConfirmAction = false;
		state.isDisabledTertiaryAction = false;
	},

	primaryActionTrigger: (state: IModal, action: PayloadAction<any>) => {
		state.secondaryActionTrigger = null;
		state.primaryActionTrigger = action.payload.data;
	},
	setIsDisabledConfirmAction: (
		state: IModal,
		action: PayloadAction<boolean>
	) => {
		state.isDisabledConfirmAction = action.payload;
	},

	secondaryActionTrigger: (state: IModal, action: PayloadAction<any>) => {
		state.primaryActionTrigger = null;
		state.secondaryActionTrigger = action.payload.data;
	},

	updatePrimaryActionText: (state: IModal, action: PayloadAction<any>) => {
		state.primaryActionText = action.payload.primaryActionText;
	},

	tertiaryActionTrigger: (state: IModal, action: PayloadAction<any>) => {
		state.primaryActionTrigger = null;
		state.secondaryActionTrigger = null;
		state.tertiaryActionTrigger = action.payload.data;
	},

	setIsDisabledTertiaryAction: (
		state: IModal,
		action: PayloadAction<boolean>
	) => {
		state.isDisabledTertiaryAction = action.payload;
	},

	setAdditionalFooterContent: (state: IModal, action: PayloadAction<any>) => {
		state.additionalFooterContent = action.payload;
	},
};
